import { useSelector } from 'react-redux';
import { PopoverCustom as PopoverMobile } from '@deprecated-ui/header';
import { selectors } from 'lib/entities/profile';

import useUIConfigStore from 'stores/useUIConfigStore';
import IconProfile from './IconProfile';
import MenuProfileTitle from './MenuProfileTitle';
import ProfileMenuReactNode from './ProfileMenuReactNode';
import { CustomPopoverContainer, PopoverContentMobile } from './styled';

const Mobile = () => {
  const { data } = useSelector(selectors);

  const remisier = useUIConfigStore((store) => store.getUIValue('remisier'));

  const adjustedData = {
    ...data,
    isCommunityAccessGranted: remisier?.isCommunityAccessGranted,
  };

  return (
    <PopoverMobile
      componentTrigger={() => (
        <IconProfile
          img={data.avatar}
          name={data.username}
          data-cy="top-navbar-icon-profile-mobile"
        />
      )}
    >
      <CustomPopoverContainer>
        <MenuProfileTitle name={data.username} />
        <PopoverContentMobile>
          {ProfileMenuReactNode(adjustedData)}
        </PopoverContentMobile>
      </CustomPopoverContainer>
    </PopoverMobile>
  );
};

export default Mobile;
